import React, { SyntheticEvent } from "react";
import cn from "classnames";

import Validation from "../Validation";

import { StyledCheckbox } from "./styles";
import { IProps } from "./interfaces";

const Checkbox = ({ label, checked, disabled, select, validation, dark, name, onChange }: IProps) => {
    const toggle = (e: SyntheticEvent) => {
        if (disabled) return;
        onChange({
            target: {
                type: "checkbox",
                name,
                checked: checked === true ? false : true,
                element: e.target,
            },
        });
    };

    return (
        <StyledCheckbox
            className={cn(disabled && "CheckboxDisabled", select && "SelectCheckbox", dark && "Dark")}
            tabIndex={0}
            onClick={toggle}
        >
            {validation && <Validation validation={validation} />}
            <div className={cn("CheckboxMark", checked && "CheckboxMarkChecked")}>
                <svg width="15" height="15">
                    <polygon points="2,7 5,10 12,3 5,10" />
                </svg>
            </div>
            <label className={"CheckboxLabel"}>
                {label}
            </label>
        </StyledCheckbox>
    );
}

export default Checkbox;
